<template>
    <div class="menu-movil">
    <div class="user-movil">
        <el-row :gutter="20">
            <el-col :xs="4" :md="1" :offset="0">
    <unicon
                name="medical-square-full"
                fill="#8bc34a"
                width="40"
                height="40"
                style="margin-top: -2px"
              />
            </el-col>
            <el-col :xs="20" :md="4" :offset="0">
 {{ farmacia.fantasia }} ({{ farmacia.codigo }})
              <br />
              <small>operador: {{ operador }}</small>
             
            </el-col>
        </el-row>
        
     
  
              </div>
 <ul >
          <li
           
            :class="{ activo: $route.name == 'inicio' }"
            @click="getRuta('inicio')"
          >
            <unicon name="home-alt" fill="#507ca0" />
            <span>INICIO</span>
          </li>
          <li
            :class="{ activo: $route.name == 'Pedidos' }"
            @click="getRuta('Pedidos')"
          >
            <unicon name="parcel" fill="#507ca0" /> <span>PEDIDOS</span>
          </li>
          <li
            v-if="domicilio"
            :class="{ activo: $route.name == 'Domicilio' }"
            @click="getRuta('Domicilio')"
          >
            <unicon name="truck" fill="#507ca0" /> <span>A DOMICILIO</span>
          </li>
          <li
            :class="{ activo: $route.name == 'comisiones' }"
            @click="getRuta('comisiones')"
          > 
            <unicon name="invoice" fill="#507ca0" style="margin-top:0px" /> <span>COMISIONES</span>
          </li>
          <li
            :class="{
              activo:
                $route.name == 'liquidaciones' || $route.name == 'liquidar',
            }"
            @click="getRuta('liquidaciones')"
          >
            <unicon name="bill" fill="#507ca0" /> <span>LIQUIDACIONES</span>
          </li>
          <li  @click="getRuta('tienda')">
            <unicon name="store" fill="#ff595a" /> <span>MI TIENDA</span>
          </li>
 <li
            :class="{ activo: $route.name == 'contacto' }"
            @click="getRuta('contacto')"
          >
            <unicon name="envelope" fill="#507ca0" /> <span>CONTACTO</span>
          </li>
          <li
           
            v-if="permiso"
            @click="getRuta('admin')"
          >
            <unicon name="shield-check" fill="#e91e63" />
            <span>ADMINISTRACIÓN</span>
          </li>
          <li
            :class="{ activo: $route.name == 'home' }"
          
            @click="deleteSession()"
          >
            <unicon name="signout" fill="#507ca0" /> <span>SALIR</span>
          </li>
          <!-- <li style="float:right"><unicon name="medical-square-full" fill="white"  /> <span>{{farmacia.fantasia}} ({{farmacia.codigo}})</span></li> -->
        </ul>
        
       <el-button type="primary" size="small" @click="cerrar">REGRESAR</el-button>
    </div>
</template>

<script>
import { EventBus } from "@/event-bus.js";

    export default {
        props:['operador','farmacia', 'domicilio', 'permiso'],
        data() {
            return {
                
            }
        },
        methods: {
              deleteSession() {
      window.sessionStorage.setItem("token", null);
      window.sessionStorage.setItem("cliente", null);
      window.sessionStorage.setItem("permisos", null);
      this.$router.push({
        name: "login",
        query: {
          token: this.$route.query.token,
        },
      });
    },
    cerrar(){
        EventBus.$emit('menuMovil',false)
    },
    getRuta(name) {
      if (name !== this.$route.name) {
        switch (name) {
          case "comisiones":
            this.estado = 40;
            break;
          case "liquidaciones":
            this.estado = 50;
            break;

          default:
            this.estado = 0;
            break;
        }
        setTimeout(() => {
             EventBus.$emit('menuMovil',false)
          this.$router.push({
            name: name,
            query: {
              token: window.sessionStorage.getItem("token"),
            },
            params: {
              dni: "",
              pedido: "",
              cliente: this.farmacia.codigo,
              estado: this.estado,
              mitienda: this.mitienda,
            },
          });
        }, 100);
      }
    },
        },
    }
</script>

<style lang="scss" scoped>
.menu-movil > ul{
    list-style: none;
    padding: 0;
    // margin-top: -20px;
}
.menu-movil > ul > li{
  font-size: 18px;
  padding: 10px;
  border-bottom: 1px solid #f1f1f1;
  display: flex;
 justify-items: center;
}
.menu-movil > ul > li > span{
margin-left: 10px;
// margin-top: 10px;
}
.user-movil{
    text-align: left;
    font-style: 18px;
    // border-bottom: 1px solid #f1f1f1;
    margin-top: -40px;
}
</style>